export default __webpack_public_path__ + "static/media/p10.d68a5cfd.jpg";